import { booleanEnv } from "./booleanEnv";
import { maxTenantsFromEnv } from "./maxTenants";

export type EdgeHostConfig = {
  maxTenants: number;
  edgeWildcardDomain: string | undefined;
  combinedSpaceTenantHosts: boolean;
  stackEdgeBaseDomain?: string;
};

export function edgeUrlStackConfigFromEnv(): EdgeHostConfig {
  return {
    maxTenants: maxTenantsFromEnv(),
    edgeWildcardDomain: process.env.EDGE_WILDCARD_DOMAIN?.trim() || undefined,
    combinedSpaceTenantHosts: booleanEnv("EDGE_COMBINED_SPACE_TENANT_HOSTS"),
    stackEdgeBaseDomain: process.env.STACK_EDGE_BASE_DOMAIN,
  };
}
